import { create } from 'zustand';

export const usePageTitleStore = create((set) => ({
  useTitle:
    'Rooftop Solar Systems & Installation | Price, Subsidy | VaySolar India',
  useDescription:
    'Get a rooftop solar system at the right price, claim 2026 subsidy and book installation in 3 clicks. VaySolar handles survey, finance and 100 % generation guarantee.',
  useImage: null,
  updateTitle: (newTitle) => set(() => ({ useTitle: newTitle })),
  updateDescription: (newDescription) =>
    set(() => ({ useDescription: newDescription })),
  updateImage: (newImage) => set(() => ({ useImage: newImage })),
}));
